import { render, staticRenderFns } from "./selected-requests-header.vue?vue&type=template&id=340cac7a&scoped=true"
import script from "./selected-requests-header.vue?vue&type=script&lang=js"
export * from "./selected-requests-header.vue?vue&type=script&lang=js"
import style0 from "./selected-requests-header.vue?vue&type=style&index=0&id=340cac7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340cac7a",
  null
  
)

export default component.exports